import { FunctionComponent } from 'react'

import { IconProps } from '@fairhq/common/lib/components/atoms/icons/types'

export const Rocket: FunctionComponent<IconProps> = ({
  className,
  fill = 'currentColor',
  width = '24',
  height = '25',
}) => (
  <svg
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    width={width}
    height={height}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.5921 10.7571L16.4254 9.92421C16.7181 9.63194 16.7181 9.15771 16.4254 8.86545L15.9929 8.43247C15.7006 8.14021 15.2264 8.14021 14.9337 8.43247L14.1003 9.26585C13.8445 9.52207 13.8267 9.91118 14.0191 10.2017L14.5333 10.7571C14.8256 11.0498 15.2998 11.0498 15.5921 10.7571ZM20.6764 4.46923L20.6855 5.96661C20.6985 8.26783 19.79 10.4783 18.1628 12.1055L14.7533 15.515C14.699 15.5688 14.669 15.6422 14.6686 15.7191L14.6656 19.6528C14.6651 19.9107 14.3533 20.0397 14.1714 19.8577L12.492 18.1845C12.3796 18.072 12.1963 18.072 12.0834 18.1849L11.4763 18.7916C11.3633 18.9049 11.1801 18.9049 11.0667 18.7916L6.06564 13.7909C5.95273 13.6776 5.95273 13.4939 6.06564 13.381L6.66277 12.7838C6.77568 12.6709 6.77524 12.4872 6.66233 12.3743L4.98647 10.7041C4.8032 10.5217 4.93218 10.2095 5.19101 10.209L9.12119 10.2056C9.19762 10.2056 9.27102 10.1752 9.3253 10.1209L12.75 6.69619C14.375 5.07157 16.582 4.16307 18.8798 4.17392L20.388 4.18087C20.5469 4.18174 20.6755 4.31029 20.6764 4.46923ZM6.27851 16.549C6.37839 16.394 6.5964 16.3706 6.72711 16.5013L8.36172 18.1359C8.49244 18.2666 8.46899 18.4846 8.31352 18.5845L3.78795 21.4976C3.51175 21.6757 3.18734 21.3513 3.3654 21.0751L6.27851 16.549Z"
      fill={fill}
    />
  </svg>
)
